import { EScreenTypes } from '@enum';

export const convertWidthToScreenType = (width: number) => {
  if (width > 1280) return EScreenTypes.desktop;
  if (width <= 1280 && width > 640) return EScreenTypes.tablet;
  return EScreenTypes.mobile;
};
